module.exports = __webpack_public_path__ + "img/IOS Store.3f75475c.svg";